/**
 * metadonneesDocument — le titre d'onglet et les metadonnees de partage,
 * dans la langue affichee.
 *
 * POURQUOI CE FICHIER EXISTE
 *
 * Ces valeurs sont ecrites en dur dans `index.html`, hors de portee de tout
 * catalogue : elles doivent exister AVANT que React demarre, pour le premier
 * rendu, pour les robots d'indexation et pour l'apercu d'un lien partage.
 *
 * Resultat mesure au navigateur : l'interface passait en anglais, mais
 * l'onglet continuait d'afficher « 1cours1bot - Assistants éducatifs » et
 * `og:title` restait francais. Le titre d'onglet est la chose la plus visible
 * apres la page elle-meme, et `og:title` est ce que voit quiconque recoit le
 * lien.
 *
 * On ne les traduit pas au catalogue mais ICI, pour la meme raison que les
 * pages autonomes embarquent leurs textes : le moment ou il faut les poser
 * precede tout chargement.
 *
 * Le francais n'est PAS declare : `index.html` le porte deja, et ne rien
 * toucher est ce qui garantit qu'un usager francophone voit exactement ce que
 * le HTML annonce.
 */

const METADONNEES = {
    en: {
        titre: '1cours1bot - Build AI teaching assistants for your students',
        description: 'Create personalized AI teaching assistants to support your students around the clock. Over 4,000 teachers use 1cours1bot to turn their lessons into interactive experiences.',
        titreCourt: '1cours1bot - AI teaching assistants',
    },
    es: {
        titre: '1cours1bot - Cree asistentes pedagógicos con IA para su alumnado',
        description: 'Cree asistentes pedagógicos personalizados con IA para acompañar a su alumnado a cualquier hora. Más de 4.000 docentes usan 1cours1bot para convertir sus clases en experiencias interactivas.',
        titreCourt: '1cours1bot - Asistentes pedagógicos con IA',
    },
    de: {
        titre: '1cours1bot - KI-Lernassistenten für Ihre Schülerinnen und Schüler',
        description: 'Erstellen Sie personalisierte KI-Lernassistenten, die Ihre Schülerinnen und Schüler rund um die Uhr begleiten. Über 4.000 Lehrkräfte nutzen 1cours1bot, um ihren Unterricht in interaktive Erfahrungen zu verwandeln.',
        titreCourt: '1cours1bot - KI-Lernassistenten',
    },
    ar: {
        titre: '1cours1bot - أنشئ مساعدين تربويين بالذكاء الاصطناعي لتلاميذك',
        description: 'أنشئ مساعدين تربويين مخصصين بالذكاء الاصطناعي لمرافقة تلاميذك على مدار الساعة. أكثر من 4000 مُعلّم يستخدمون 1cours1bot لتحويل دروسهم إلى تجارب تفاعلية.',
        titreCourt: '1cours1bot - مساعدون تربويون بالذكاء الاصطناعي',
    },
};

/** Pose (ou remplace) le contenu d'une balise meta, si elle existe. */
const poserMeta = (selecteur, valeur) => {
    const balise = document.querySelector(selecteur);
    if (balise && valeur) balise.setAttribute('content', valeur);
};

/**
 * Aligne le titre et les metadonnees sur la langue affichee.
 *
 * Ne fait RIEN pour le francais : `index.html` le porte deja, et le laisser
 * intact garantit qu'un usager francophone voit exactement ce que le HTML
 * annonce — y compris avant que ce code s'execute.
 *
 * Une langue sans entree est traitee comme le francais : mieux vaut un titre
 * francais qu'un titre vide.
 */
export const appliquerMetadonnees = (code) => {
    if (typeof document === 'undefined') return;

    const m = METADONNEES[code];
    if (!m) return;

    document.title = m.titre;
    poserMeta('meta[name="description"]', m.description);
    poserMeta('meta[property="og:title"]', m.titre);
    poserMeta('meta[property="og:description"]', m.description);
    poserMeta('meta[name="twitter:title"]', m.titreCourt);
    poserMeta('meta[name="twitter:description"]', m.description);
};

/**
 * Le titre d'onglet de la langue affichee.
 *
 * `usePageNotifications` le reecrit a chaque changement du compteur de
 * non-lus. Il portait une chaine francaise ecrite en dur, si bien que
 * l'onglet repassait au francais des qu'une notification arrivait — dans
 * toutes les langues, et sans que rien d'autre change a l'ecran.
 *
 * Rend le titre francais d'`index.html` quand la langue n'a pas d'entree :
 * c'est ce que le HTML annonce deja.
 */
export const titreDeBase = (code) =>
    METADONNEES[code]?.titre || '1cours1bot - Assistants éducatifs';

export default appliquerMetadonnees;
